export const START_TIMER = 'START_TIMER';
export const CONTINUE_TIMER = 'CONTINUE_TIMER';
export const STOP_TIMER = 'STOP_TIMER';
export const RESET_TIMER = 'RESET_TIMER';

export const startTimer = () => ({
    type: START_TIMER,
    payload: {
        timestamp: Date.now(),
    },
});

export const continueTimer = () => ({
    type: CONTINUE_TIMER,
});

export const stopTimer = () => ({
    type: STOP_TIMER,
    payload: {
        timestamp: Date.now(),
    },
});

export const resetTimer = () => ({
    type: RESET_TIMER,
});

export const getTimerData = (state) => state.timerReducer;
